import React, { useState, useCallback } from "react";
import { GoogleMap, Marker, useJsApiLoader } from "@react-google-maps/api";
import { useNavigate } from "react-router-dom";
import "./ChangeLocation.css";

const containerStyle = {
  width: "100%",
  height: "80vh",
};

const defaultCenter = {
  lat: 37.7749,
  lng: -122.4194,
};

const ChangeLocation = () => {
  const navigate = useNavigate();
  const [marker, setMarker] = useState(null);
  const [address, setAddress] = useState("");

  // Load Google Maps
  const { isLoaded } = useJsApiLoader({
    googleMapsApiKey: "AIzaSyDQY2FwULc0QTtDZ3FUMls29fHHsr2R3ag",
  });

  const handleMapClick = useCallback(async (e) => {
    const lat = e.latLng.lat();
    const lng = e.latLng.lng();
    setMarker({ lat, lng });

    // Reverse Geocoding
    try {
      const res = await fetch(
        `https://maps.googleapis.com/maps/api/geocode/json?latlng=${lat},${lng}&key=AIzaSyDQY2FwULc0QTtDZ3FUMls29fHHsr2R3ag`
      );
      const data = await res.json();
      if (data.status === "OK" && data.results.length > 0) {
        setAddress(data.results[0].formatted_address);
      } else {
        setAddress("Unknown Location");
      }
    } catch (err) {
      console.error("Error fetching address", err);
      setAddress("Unable to fetch address");
    }
  }, []);

  const handleConfirm = () => {
    if (!marker || !address) return;

    const selectedLocation = { ...marker, address };

    // Save to localStorage
    const stored = localStorage.getItem("savedLocations");
    const savedList = stored ? JSON.parse(stored) : [];
    const exists = savedList.some(
      (loc) => loc.lat === selectedLocation.lat && loc.lng === selectedLocation.lng
    );
    if (!exists) savedList.push(selectedLocation);

    localStorage.setItem("savedLocations", JSON.stringify(savedList));
    localStorage.setItem("selectedAddress", JSON.stringify(selectedLocation));

    navigate(-1); // Go back to previous page
  };

  if (!isLoaded) return <p>Loading Map...</p>;

  return (
    <div className="cl-container">
      <GoogleMap
        mapContainerStyle={containerStyle}
        center={marker || defaultCenter}
        zoom={15}
        onClick={handleMapClick}
      >
        {marker && <Marker position={marker} />}
      </GoogleMap>

      <div className="cl-addressBox">
        <p>
          <strong>Selected Location:</strong> {address || "Click on map"}
        </p>
        <button className="cl-confirmBtn" onClick={handleConfirm}>
          Confirm Location
        </button>
      </div>
    </div>
  );
};

export default ChangeLocation;
